import script from "./CheckboxSelectMessage.vue?vue&type=script&setup=true&lang=ts"
export * from "./CheckboxSelectMessage.vue?vue&type=script&setup=true&lang=ts"

import "./CheckboxSelectMessage.vue?vue&type=style&index=0&id=7a83f117&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7a83f117"]])

export default __exports__